'use client';

export type BaseEventMeta = {
    currentUrl: URL;
    referrer?: URL;
    visitorCookieId: string | null; // "VID"
    sessionToken?: string; // "login_session"
};

export type BuildBaseMetaParams = {
    explicitUrl?: string; // override window.location.href if needed
    explicitReferrer?: string; // override document.referrer if needed
};

function getCookie(name: string): string | undefined {
    const parts = document.cookie?.split(';') ?? [];
    for (const part of parts) {
        const t = part.trim();
        if (t.startsWith(name + '=')) return decodeURIComponent(t.slice(name.length + 1));
    }
    return undefined;
}

function getSessionToken(): string | undefined {
    return getCookie('login_session') ?? undefined;
}

function getVisitorId(): string | null {
    return getCookie('VID') ?? null;
}

function safeParseURL(input?: string | null): URL | undefined {
    if (!input) return undefined;
    try {
        return new URL(input);
    } catch {
        return undefined;
    }
}

function computeCurrentUrl(explicitUrl?: string): URL {
    const href = explicitUrl || window.location?.href || 'about:blank';
    return new URL(href);
}

function computeReferrer(explicitReferrer?: string): URL | undefined {
    if (explicitReferrer) return safeParseURL(explicitReferrer);
    if (document.referrer) return safeParseURL(document.referrer);

    try {
        const topRef = (window.frames?.top as Window | undefined)?.document?.referrer;
        return safeParseURL(topRef);
    } catch {
        return undefined;
    }
}

export function buildBaseInteractionMeta(params: BuildBaseMetaParams = {}): BaseEventMeta {
    return {
        currentUrl: computeCurrentUrl(params.explicitUrl),
        referrer: computeReferrer(params.explicitReferrer),
        visitorCookieId: getVisitorId(),
        sessionToken: getSessionToken(),
    };
}
